export function featureFlagFn(
  nombre: string,
  usuario: { esSuperusuario: boolean },
  flags: Record<string, boolean> = {},
): boolean {
  return usuario.esSuperusuario || !!flags[nombre];
}
